import Swiper from "swiper/bundle";
import gsap from "gsap";
import { TimelineMax } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Scrollbar from "smooth-scrollbar";
import { isMobile, isDesktop } from "./exportFunc";

export default () => {
  gsap.registerPlugin(ScrollTrigger);

  //#region VARIABLES
  const header = document.querySelector("[header]");
  const button = document.querySelector("[menu-open]");
  const menu = document.querySelector("[menu-main]");
  const lang = document.querySelector("[lang-open]");
  const langMenu = document.querySelector("[menu-lang]");
  const menuLinks = document.querySelectorAll(".menu-left__link"); //TODO: CHANGE TO CLASS!!!
  const submenus = document.querySelectorAll("[submenu]");
  const submenuLinks = document.querySelectorAll(".submenu__link");
  const submenusWrapper = document.querySelector(".submenus");
  const img = document.querySelector("[change-img]");
  const menuLeft = document.querySelector(".menu-left");
  const menuRight = document.querySelector(".menu-right");
  const rightBg = document.querySelector(".right-bg");
  const backButtons = [...document.querySelectorAll(".submenu__link--back")];
  const closeBtn = document.querySelector(".language-popup__btn");
  const languagePopup = document.querySelector(".language-popup__wrapper");
  const popupLangLinks = document.querySelectorAll(".language-popup__item");
  let removeNewPopup = false;

  const allBoxes = [...submenus, menuLeft];
  let componentHeigh;
  //#endregion

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // Setting cookies for window language selected

  let languageCookie = getCookie("choosenLanguage");
  let isSetLanguage = sessionStorage.getItem("isSetLanguage");
  let isSetLangNewPopup = sessionStorage.getItem("isSetLangNewPopup");

  function createCookie(name, value, days) {
    var date, expires;
    if (days) {
      date = new Date();
      date.setDate(date.getDate() + days);
      expires = "; expires=" + date.toUTCString();
    } else {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  // console.log('after return')
  popupLangLinks.forEach((el) => {
    el.addEventListener("click", function () {
      createCookie("choosenLanguage", `${el.href}`, 90);
      // document.cookie = `choosenLanguage=; expires=90; path=/; maxAge: 31536000;`;
    });
  });

  if (languageCookie) {
    if (!isSetLanguage) {
      window.location.href = languageCookie;
      sessionStorage.setItem("isSetLanguage", "true");
    }
  }

  //#region CALCULATE HEIGHT
  if (!isMobile()) {
    let height = 0;
    let h;

    allBoxes.forEach((box) => {
      let positionInfo = getComputedStyle(box);
      h = parseInt(positionInfo.paddingBottom);

      if (box.scrollHeight > height) {
        height = box.scrollHeight;
      }
    });
    allBoxes.forEach((box) => {
      componentHeigh = h + height + "px";
      box.style.height = componentHeigh;
      menu.setAttribute("data-height", componentHeigh);
      rightBg.style.height = componentHeigh;
      document.querySelector(".menu-slider").style.height = componentHeigh;
      document.querySelectorAll(".menu-slider .item").forEach((el) => {
        el.style.height = componentHeigh;
      });
    });
  }

  //#endregion

  //#region MENU
  gsap.set(menu, { height: 0 });
  gsap.set(menuLeft, { opacity: 0 });
  gsap.set(menuRight, { opacity: 0 });
  button.addEventListener("click", () => {
    button.querySelector("[ham]").classList.toggle("open");

    if (menu.classList.contains("open")) {
      menuLinks.forEach((el) => {
        el.classList.remove("unhovered");
      });
      gsap.to(menu, {
        onComplete: () => {
          header.classList.remove("open");
          menu.classList.remove("open");
          gsap.set(menuLeft, { opacity: 0 });
          gsap.set(menuRight, { opacity: 0 });
        },
        height: 0,
        ease: "Power3.easeOut",
      });
      submenus.forEach((sub) => {
        sub.classList.remove("open");
        rightBg.classList.remove("open");
      });
    } else {
      let a;
      isMobile() ? (a = "calc(100vh - 58px)") : (a = componentHeigh);

      gsap.to(menu, {
        duration: 0.75,
        height: a,
        ease: "Power4.inOut",
        onStart: () => {
          header.classList.add("open");
          menu.classList.add("open");
          gsap.set(".submenu__link", {
            x: -30,
            opacity: 0,
          });
        },
        onComplete: () => {
          gsap.to(menuLeft, {
            opacity: 1,
            duration: 0.5,
            ease: "Power1.easeIn",
            onComplete: () => {
              gsap.to(menuRight, {
                opacity: 1,
                duration: 1,
                ease: "Circ.easeIn",
              });
            },
          });
        },
      });
    }
  });
  //#endregion

  //#region LANG
  const toggleLangPopup = () => {
    lang.addEventListener("click", () => {
      console.log("lang open click");
      langMenu.classList.toggle("open");
    });

    closeBtn.addEventListener("click", () => {
      langMenu.classList.remove("open");
        languagePopup.classList.remove("language-popup__languagePopup");
        languagePopup.classList.remove("language-popup__languagePopup__transition");
        languagePopup.classList.remove("language-popup__languagePopup__visible");
        removeNewPopup = true;
        sessionStorage.setItem("isSetLangNewPopup", "true");

    });

    langMenu.addEventListener("click", function (event) {
      if (event.target.closest(".language-popup")) return;
      langMenu.classList.remove("open");
    });
  };

  toggleLangPopup();
  //#endregion
  //   console.log("Header " + scrollStatus);

  //#region SCROLL

  if (isMobile()) {
    Scrollbar.init(document.querySelector(".menu-right .submenus"), {});
  }

  let scrollStatus;
  let oldScroll = 0;
  let scrollbar = Scrollbar.get(document.querySelector(".scroll-container"));
  const firstSection = document.querySelector("main section");

  scrollbar.addListener((status) => {
    const mainMenu = document.querySelector(".header__menu--main");
    if (mainMenu.classList.contains("open")) {
      return;
    }
    scrollStatus = status.offset.y;

    // If we have cookies for language not to show popup from right
    if (!languageCookie) {
      // console.log(isSetLangNewPopup)
      if (!isSetLangNewPopup && !removeNewPopup) {
        if (scrollStatus > "20") {
          languagePopup.classList.add("language-popup__languagePopup");
          languagePopup.classList.add(
            "language-popup__languagePopup__transition"
          );
        }
        if (scrollStatus > "600") {
          languagePopup.classList.add("language-popup__languagePopup__visible");
        }
      }
    }
    // End popup function

    if (oldScroll > scrollStatus) {
      header.classList.remove("scroll-down");
      header.classList.add("fill");

      if (firstSection) {
        if (scrollStatus < firstSection.offsetHeight) {
          header.classList.remove("fill");
        }
      }
    } else {
      header.classList.remove("fill");
      header.classList.add("scroll-down");
      header.classList.remove("open");
      menu.classList.remove("open");
      langMenu.classList.remove("open");
      button.querySelector("[ham]").classList.remove("open");

      gsap.to(menu, {
        onComplete: () => {
          header.classList.remove("open");
          menu.classList.remove("open");
          gsap.set(menuLeft, { opacity: 0 });
          gsap.set(menuRight, { opacity: 0 });
        },
        height: 0,
        ease: "Power3.easeOut",
        duration: 0,
      });
      submenus.forEach((sub) => {
        sub.classList.remove("open");
        rightBg.classList.remove("open");
      });
    }
    oldScroll = scrollStatus;
  });

  //#endregion

  //#region SUBMENU
  const hasSubmenuLinks = [...document.querySelectorAll("[data-hassubmenu]")];

  const openSubMenu = (el, link) => {
    submenusWrapper.classList.add("open");
    el.classList.add("open");
    link.classList.add("open");

    const elements = [...el.querySelectorAll(".submenu__link")];

    rightBg.classList.add("open");
    gsap.fromTo(
      img,
      {
        x: -25,
      },
      {
        x: 0,
        ease: "Power1.easeOut",
        duration: 1,
      }
    );
    img.src = elements[0].dataset.image;

    const options = {
      x: 0,
      opacity: 1,
      ease: "Power4.inOut",
    };

    const tl = new TimelineMax();
    tl.staggerTo(elements, 0.5, options, 0.2);
  };

  const closeSubMenus = () => {
    const allSubmenus = [...document.querySelectorAll(".submenu")];
    submenusWrapper.classList.remove("open");

    rightBg.classList.remove("open");

    hasSubmenuLinks.forEach((el) => {
      el.classList.remove("open");
    });

    allSubmenus.forEach((el) => {
      el.classList.remove("open");
      const elements = [...el.querySelectorAll(".submenu__link")];
      const options = {
        x: 30,
        opacity: 0,
      };
      gsap.set(elements, options);
    });
  };

  const findSubmenu = (link) => {
    const dataTarget = link.dataset.hassubmenu;
    const submenuItem = document.querySelector(
      `[data-submenu="${dataTarget}"]`
    );

    if (!submenuItem) {
      return;
    }
    closeSubMenus();
    openSubMenu(submenuItem, link);
  };

  hasSubmenuLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      findSubmenu(link);
    });
    link.addEventListener("mouseenter", () => {
      findSubmenu(link);
    });
  });

  menuLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      if (!link.dataset.hassubmenu) {
        closeSubMenus();
      }

      menuLinks.forEach((el) => {
        if (!el.classList.contains("open")) {
          el.classList.add("unhovered");
        }
      });

      link.classList.remove("unhovered");
    });

    link.addEventListener("mouseleave", () => {
      let opened = false;
      menuLinks.forEach((el) => {
        if (el.classList.contains("open")) {
          opened = true;
        }
      });

      if (!opened) {
        menuLinks.forEach((el) => {
          el.classList.remove("unhovered");
        });
      }
    });
  });

  const mainMenu = document.querySelector(".header__menu--main");

  mainMenu.addEventListener("mouseleave", () => {
    closeSubMenus();
  });

  //show first submenu

  //show second submenu
  submenuLinks.forEach((link) => {
    link.addEventListener("mouseover", () => {
      rightBg.classList.add("open");
      img.src = link.dataset.image;
      gsap.fromTo(
        img,
        {
          scale: 1,
          duration: 0,
        },
        {
          scale: 1.05,
          ease: "power1.out",
          duration: 1,
        }
      );
    });
  });

  // go-back button
  backButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      submenus.forEach((sub) => {
        sub.classList.remove("open");
        submenusWrapper.classList.remove("open");
      });
    });
  });

  //#endregion

  //#region SLIDER
  const sliderList = document.querySelector(".menu-slider__container");
  if (sliderList && !isMobile()) {
    let slider = new Swiper(sliderList, {
      slidesPerView: "auto",
      loop: true,
      speed: 600,
      allowTouchMove: false,
      autoplay: {
        delay: 10000,
      },
      pagination: {
        el: ".menu-slider__pagination",
        clickable: true,
        currentClass: "menu-slider__pagination--current",
        totalClass: "menu-slider__pagination--total",
        type: "bullets",
        type: "fraction",
        renderFraction: function (currentClass, totalClass, index) {
          // console.log("aceeeee" + totalClass )

          return (
            '<div><span class="' +
            currentClass +
            '"></span>' +
            '<span class="' +
            totalClass +
            '"></span></div>'
          );
        },
        formatFractionTotal: function (index) {
          return "0" + index;
        },
        formatFractionCurrent: function (index) {
          return "0" + index;
        },
      },
    });

    slider.autoplay.stop();

    button.addEventListener("click", () => {
      slider.autoplay.start();
      setActivepagination();
    });
    //VARS
    let pagination = document.querySelector(".menu-slider__pagination");
    let curPag = document.querySelector(".menu-slider__pagination--current");

    //If total pagination is 01 to hide the slidesPerView numbers
    let totalPag = document.querySelector(".menu-slider__pagination--total");

    if (totalPag.innerHTML == "01") {
      curPag.style.display = "none";
      totalPag.style.display = "none";
    }

    // ___ END ___  If total pagination is 01 to hide the slidesPerView numbers

    let link = document.createElement("a");
    link.className = "menu-slider__pagination--link";

    let activeSlide = document.querySelector(
      ".menu-slider__container .swiper-slide-active"
    );
    setLink(activeSlide);
    setActivepagination();

    slider.on("slideChange", function () {
      let current = document.querySelector(".swiper-slide-next");
      setActivepagination();
      setLink(current);
    });

    function setLink(current) {
      if (current.dataset.href.length > 0 && current.dataset.title.length > 0) {
        link.href = current.dataset.href;
        link.innerHTML = current.dataset.title;
        pagination.append(link);
      } else {
        const oldLink = pagination.querySelector(
          ".menu-slider__pagination--link"
        );
        oldLink ? oldLink.remove() : false;
      }
    }

    function setActivepagination() {
      curPag.classList.remove("active");
      setTimeout(() => {
        curPag.classList.add("active");
      }, 1);
    }
  }

  //#endregion
};

//  let scrollpos = window.scrollY;

//  const langBox = document.querySelector(".language-popup__wrapper");

//  const scrollChange = 100;

//  const add_class_on_scroll = () => langBox.classList.add("open");

//  const remove_class_on_scroll = () => langBox.classList.remove("open");

//  window.addEventListener("scroll", function () {
//    scrollpos = window.scrollY;

//    console.log(scrollpos + " aceeeeeeee ");

//    if (scrollpos >= scrollChange) {
//      add_class_on_scroll();
//    } else {
//      remove_class_on_scroll();
//    }
//  });
